// extracted by mini-css-extract-plugin
export default {"wrapper":"EnabledDisabledIcons_wrapper__jFFIf","icon":"EnabledDisabledIcons_icon__pWhXY","label":"EnabledDisabledIcons_label__9EYJh"};